import type { CartItem } from '@backmarket/nuxt-layer-checkout/api/cart/types'

export function getAvailableItems(items: CartItem[]): CartItem[] {
  return items.filter((item) => item.available === 'yes')
}
